import React, { useEffect, useState } from "react";
import { Table, Row, Col, Button } from "antd";
import { useParams } from "react-router-dom";
import vendorQuotation from "../../../services/vendor-quotation-service";
import { PrinterOutlined } from '@ant-design/icons'

import { DG, NON_DG } from "../../../constants";
import { changeDocumentTitle } from "../../../utils/title";

function VendorQuotation() {
  const [viewBrowses, setViewBrowses] = useState([]);
  const [filteredViewBrowse, setFilteredViewBrowse] = useState(viewBrowses);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [quotation, setQuotation] = useState(null);

  let { id } = useParams();

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Destination",
      dataIndex: "destination",
      key: "destination",
      render: (text) => text.toUpperCase()
    },
    {
      title: "Container",
      dataIndex: "containersize",
      key: "containersize",
    },
    {
      title: "DG/ NON DG",
      dataIndex: "is_dg",
      key: "is_dg",
      render: (text, record) => <span>{record.is_dg === 1 ? DG : NON_DG}</span>,
    },
    {
      title: "Charges",
      dataIndex: "charges",
      key: "charges",
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.pageSize) => {
    setLoading(true);
    const { success, data } = await vendorQuotation.viewQuotation(id);
    setLoading(false);
    if (success) {
      setQuotation(data.quotation);
      setViewBrowses(data.details);
      setFilteredViewBrowse(data.details);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printableDiv").innerHTML;
    const originalContent = document.body.innerHTML;

    // Add print-specific styles
    document.body.innerHTML = `
      <style>
        @media print {
          body {
            font-size: 20px; /* Base font size */
            line-height: 1.6;
            padding: 0;
          }
          h3 {
            font-size: 50px !important;
            font-weight: bold;
          }
          .top-section {
            margin-bottom: 20px;
          }
          ul {
            font-size: 20px;
            margin-bottom: 20px;
            line-height: 1.8;
          }
          li {
            margin: 5px;
          }
          .table-div {
            margin-left: 0px !important;
          }
          .ant-table {
            font-size: 20px;
          }
          .ant-table-thead > tr > th {
          font-size: 20px;
          padding: 14px;
          background-color: #f0f0f0;
        }
        .ant-table-tbody > tr > td {
          font-size: 20px;
          padding: 14px;
        }
        }
      </style>
      <div id="printableDiv">${printContent}</div>
    `;

    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload(); // Restore state and events
  };


  useEffect(() => {
    changeDocumentTitle("View Vendor Quotations");
    initialize();
  }, []);

  return (
    <div
      id="printableDiv"
      style={{
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      {/* Header Content */}
      <Row gutter={16}>
        <Col span={20}>
          {quotation && (
            <div className="top-section">
              <h3
                style={{ fontWeight: "bold", fontSize: "20px" }}
                className="mb-8"
              >
                Hello {quotation?.vendor_name}{" "}
              </h3>
              <ul style={{ lineHeight: "1.8", margin: 0 }}>
                <li>LOADING/FREIGHT RATES ARE AS ATTACHED.</li>
                <li>
                  ABOVE RATES INCLUSIVE OF {quotation?.chassis_days} THEREAFTER{" "}
                  {quotation?.chassis_charges} PER CHASIS.
                </li>
                <li>PAYMENT TERMS: 7 DAYS FROM THE DATE OF INVOICE.</li>
                <li>
                  LOADING PICTURES WILL BE PROVIDED TO SATISFY THE CUSTOMERS IN
                  ADVANCE.
                </li>
                <li>
                  CHEQUE BOOK PROVIDED FOR ISSUANCE OF CHEQUES TO CUSTOMERS WITH
                  THEIR OWN DISPATCH.
                </li>
                <li>DEDICATED CUSTOMER SERVICE FOR VOLUMETRIC CUSTOMERS.</li>
                <li>
                  STORAGE POLICY: {quotation?.chassis_days} THEREAFTER{" "}
                  {quotation?.chassis_charges} PER UNIT.
                </li>
                <li>
                  DRIVERS MUST CONTACT PRIOR TO DELIVERY OR EMAIL THE DISPATCH
                  SHEETS FOR PROPER DELIVERY AND NO DELAYS.
                </li>
                <li>ADVANCE BOOKINGS BASED ON VOLUME COMMITMENT.</li>
                <li>7 ACRES OF PARKING SPACE.</li>
                <li>
                  WE REQUEST THAT THE LOADING PLAN BE SENT 48 TO 72 BUSINESS
                  HOURS IN ADVANCE OF FIRST RECEIVING.
                </li>
                <li>
                  IF CUSTOMERS NEED TO PICK UP VEHICLES, IT WILL BE SUBJECT TO
                  $100 PER VEHICLE, ALONG WITH STORAGE CHARGES AFTER 30 DAYS OF
                  RECEIVING AT THE FACILITY.
                </li>
                <li>
                  IN-HOUSE DRAYAGE NETWORK WITH OWN CHASIS FOR SMOOTH
                  OPERATIONS.
                </li>
              </ul>
            </div>
          )}
        </Col>
      </Row>
      {/* Table Section */}
      <div
        className="table-div"
        style={{
          margin: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <Table
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={filteredViewBrowse}
          loading={loading}
          pagination={false}
        />
      </div>
      <Row>
        <Col span={24} style={{ textAlign: "right", padding: 20 }}>
          <Button type="primary" onClick={handlePrint} className="no-print">
            <PrinterOutlined /> Print
          </Button>
        </Col>
      </Row>
    </div>
  );
}
export default VendorQuotation;
